import {GetEnumValueName} from "./EnumHelper";

export const GetNotificationTitle = (notification) => {
    switch (notification.type) {
        case 3:
        case 0:
            return GetEnumValueName('internalNotificationType', notification.type);
        case 1:
        case 2:
            return notification.metaObj.Title;
        default:
            return 'Unhandled type';
    }
};